import styles from "@/styles/Video.module.scss";
import AgeRestriction from "./AgeRestriction";
import AppKick from "./AppKick";
import DvrLive from "./DvrLive";
import EntitlementConfirm from "./EntitlementConfirm";
import LiveBefore from "./LiveBefore";
import NeedLogin from "./NeedLogin";
import NextEpisode from "./NextEpisode";
import NoEntitled from "./NoEntitled";
import OverlayError from "./OverlayError";
import ResumeSelect from "./ResumeSelect";
import SuggestApp from "./SuggestApp";
import ChatSelect from "./ChatSelect";
import { useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function VideoOverlay(_ref) {
  let {
    watch,
    state,
    error,
    poster,
    isChatAvailableMeta,
    setChatDisplay,
    isValidChatPeriod,
    chatDisplay
  } = _ref;
  const {
    nextEpisode
  } = watch;
  const {
    0: isChatSelected,
    1: setIsChatSelected
  } = useState(!(isChatAvailableMeta && isValidChatPeriod) || chatDisplay);
  useEffect(() => {
    setIsChatSelected(!(isChatAvailableMeta && isValidChatPeriod) || chatDisplay);
  }, [isChatAvailableMeta, isValidChatPeriod, chatDisplay]);
  if (!state.overlay && !error) return null;else if (state.reason === "chat_select" && chatDisplay) {
    // チャット表示済みの場合、チャットを表示して再生するかの選択を出さないようにする
    state.updateResumePoint(0);
    return null;
  } else if (state.reason === "next_episode" && !nextEpisode) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.overlay,
    children: [state.reason === "needlogin" && /*#__PURE__*/_jsx(NeedLogin, {
      watch: watch
    }), state.reason === "needlogin_and_contract" && /*#__PURE__*/_jsx(NeedLogin, {
      withContract: true,
      watch: watch
    }), state.reason === "entitlement_confirm" && /*#__PURE__*/_jsx(EntitlementConfirm, {
      state: state
    }), state.reason === "geolocation" && /*#__PURE__*/_jsx(OverlayError, {
      message: state.error.message,
      error: state.error
    }), state.reason === "suggest_app" && /*#__PURE__*/_jsx(SuggestApp, {
      watch: watch,
      state: state
    }), state.reason === "resume" && !isChatSelected && /*#__PURE__*/_jsx(ChatSelect, {
      setChatDisplay: setChatDisplay,
      setIsChatSelected: setIsChatSelected,
      reason: state.reason,
      play: false,
      state: state
    }), state.reason === "resume" && isChatSelected && /*#__PURE__*/_jsx(ResumeSelect, {
      state: state
    }), state.reason === "live_before" && /*#__PURE__*/_jsx(LiveBefore, {
      watch: watch,
      state: state,
      isChatAvailableMeta: isChatAvailableMeta,
      setChatDisplay: setChatDisplay
    }), state.reason === "dvr_live" && !isChatSelected && /*#__PURE__*/_jsx(ChatSelect, {
      setChatDisplay: setChatDisplay,
      setIsChatSelected: setIsChatSelected,
      reason: state.reason,
      play: false,
      state: state
    }), state.reason === "dvr_live" && isChatSelected && /*#__PURE__*/_jsx(DvrLive, {
      state: state
    }), state.reason === "appkick" && /*#__PURE__*/_jsx(AppKick, {
      watch: watch
    }), state.reason === "rating" && /*#__PURE__*/_jsx(AgeRestriction, {
      watch: watch
    }), state.reason === "next_episode" && /*#__PURE__*/_jsx(NextEpisode, {
      watch: watch,
      state: state
    }), state.reason === "playback_error" && /*#__PURE__*/_jsxs(_Fragment, {
      children: [state.error.reason == "not_delivery_started" && /*#__PURE__*/_jsx(OverlayError, {
        poster: poster,
        error: state.error,
        isChatAvailableMeta: isChatAvailableMeta,
        setChatDisplay: setChatDisplay
      }), state.error.reason == "not_entitled" && /*#__PURE__*/_jsx(NoEntitled, {
        watch: watch
      }), !["not_entitled", "not_delivery_started"].includes(state.error.reason) && /*#__PURE__*/_jsx(OverlayError, {
        error: state.error,
        isChatAvailableMeta: isChatAvailableMeta,
        setChatDisplay: setChatDisplay
      })]
    }), state.reason === "error" && /*#__PURE__*/_jsx(OverlayError, {
      error: state.error,
      isChatAvailableMeta: isChatAvailableMeta,
      setChatDisplay: setChatDisplay
    }), error && /*#__PURE__*/_jsx(OverlayError, {
      error: error
    }), state.reason === "chat_select" && /*#__PURE__*/_jsx(ChatSelect, {
      setChatDisplay: setChatDisplay,
      setIsChatSelected: setIsChatSelected,
      reason: state.reason,
      play: true,
      state: state
    })]
  });
}